import { useContext, Children } from 'react';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom';

import Button from 'components/button';
import { UserContext } from 'contexts/user';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

export const TabPane = ({ children }) => <div>{children}</div>;

export const Tabz = ({ loading, children, currentTab, onSave }) => {
  const history = useHistory();
  const { user } = useContext(UserContext);

  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const onTabClick = (tabName) => {
    history.push(`?tab=${tabName}`);
  };

  const renderTabs = () =>
    Children.map(children, (item, index) => (
      <div
        key={index}
        className={classNames(
          item.props.title.toLowerCase() === currentTab
            ? 'purple'
            : 'text-gray-500 hover:text-gray-700',
          index === 0 ? 'rounded-l-lg' : '',
          index === children.length - 1
            ? 'rounded-r-lg bl b--lightgrey-d1'
            : 'bl b--lightgrey-d1',
          'flex pointer relative min-w-0 overflow-hidden bg-white',
        )}
        onClick={() => onTabClick(item.props.title.toLowerCase())}
      >
        <span className="fw5 pt3 pb3 pl9 pr9">{item.props.title}</span>
        <span
          className={classNames(
            item.props.title.toLowerCase() === currentTab
              ? 'bg-purple h05'
              : 'bg-whitegrey h025',
            'absolute inset-x-0 bottom-0 w-100',
          )}
        />
      </div>
    ));

  const renderActiveTabContent = () =>
    Children.toArray(children).find(
      (item) => item.props.title.toLowerCase() === currentTab,
    )?.props.children;

  const DesktopView = (
    <div className="mt10 db">
      <nav className="flex flex-row justify-between items-start">
        <div className="flex">{renderTabs()}</div>
        {onSave && currentTab === 'details' && user.type !== 'non-sleep' && (
          <Button
            label="Save"
            loading={loading}
            className="btn-purple"
            onClick={onSave}
          />
        )}
      </nav>
      {renderActiveTabContent()}
    </div>
  );

  const MobileView = (
    <div className="mt10 db">
      <nav className="flex flex-row justify-between items-start">
        <div className="flex">{renderTabs()}</div>
      </nav>
      {renderActiveTabContent()}
      {onSave && currentTab === 'details' && user.type !== 'non-sleep' && (
        <div className="mt4">
          <Button
            label="Save"
            loading={loading}
            className="w-100 btn-purple"
            onClick={onSave}
          />
        </div>
      )}
    </div>
  );

  return isMobile ? MobileView : DesktopView;
};

export default Tabz;
